// extracted by mini-css-extract-plugin
export default {"root":"IconCamping_root__llcn1"};